import React from 'react';
import {EmissionsModel} from '../../typings/general';
import {CarHeader} from './car-header';
import {MatchInformation} from './match-information';
import {ResultSectionContainer} from './styled';

interface ResultsSectionProps {
  emissionsData: EmissionsModel;
}
export const ResultsSection: React.FC<ResultsSectionProps> = props => {
  const {emissionsData} = props;

  return (
    <ResultSectionContainer>
      <CarHeader model={emissionsData.model} />
      <MatchInformation emissionsData={emissionsData} />
    </ResultSectionContainer>
  );
};
